<script setup lang="ts">
import Switcher from '@kidzonet/dark-mode-switcher'
</script>

<template>
    <div class="kidzonet-vuetify-switcher-overrides">
        <Switcher
            inset
        />
    </div>
</template>

<style>
    @import '@kidzonet/styles-vuetify-switcher'
</style>
